export type View = string

export enum RowAlign {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}